import { render, staticRenderFns } from "./RoleMeta.vue?vue&type=template&id=15acd140&scoped=true"
import script from "./RoleMeta.vue?vue&type=script&lang=js"
export * from "./RoleMeta.vue?vue&type=script&lang=js"
import style0 from "./RoleMeta.vue?vue&type=style&index=0&id=15acd140&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15acd140",
  null
  
)

export default component.exports